<template>
    <tr name="hres80x-heal-illness1-detail">
      <td class="text-center">{{numseq}}</td>
      <td >{{description}}</td>
      <td class="text-center">
        <input type="checkbox" :name="'flgHeal' + numseq" :checked="value === '0'">
      </td>
      <td class="text-center">
        <input type="checkbox" :name="'flgHeal' + numseq" :checked="value === '1'">
      </td>
      <td>{{remark}}</td>
    </tr>
</template>

<script>
export default {
  name: 'hres80x-heal-illness1-detail',
  props: [
    'numseq',
    'description',
    'value',
    'remark'
  ]
}
</script>



// WEBPACK FOOTER //
// healIllness1Detail.vue?6ad25d62